import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Field } from "@/components/common";

const KEYS = [["brands", "Brands"], ["categories", "Product categories"], ["warehouses", "Warehouses"], ["units", "Units of measurement"], ["conductors", "Conductor materials"], ["armour_types", "Armour types"], ["voltage_grades", "Voltage grades"]];

function Lookups() {
  const { lookups, setLookups } = useAuth();
  const [f, setF] = useState({});
  useEffect(() => { if (lookups) setF(Object.fromEntries(KEYS.map(([k]) => [k, (lookups[k] || []).join("\n")]))); }, [lookups]);
  const save = async () => {
    try {
      const body = Object.fromEntries(KEYS.map(([k]) => [k, (f[k] || "").split("\n")]));
      const { data } = await api.put("/lookups", body);
      setLookups(data);
      toast.success("Configuration saved");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <section className="rounded-lg border bg-card p-4 space-y-3">
      <h2 className="font-heading font-semibold">Master lists</h2>
      <p className="text-xs text-muted-foreground">One value per line. Removing a value does not alter existing records.</p>
      <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-3">
        {KEYS.map(([k, l]) => <Field key={k} label={l}><Textarea rows={7} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`lookups-${k}-input`} /></Field>)}
      </div>
      <Button onClick={save} data-testid="lookups-save-btn">Save configuration</Button>
    </section>
  );
}

function Password() {
  const { reload } = useAuth();
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const save = async () => {
    try { await api.post("/auth/change-password", { current_password: cur, new_password: nw }); toast.success("Password changed"); setCur(""); setNw(""); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <section className="rounded-lg border bg-card p-4 space-y-3 max-w-md">
      <h2 className="font-heading font-semibold">Change password</h2>
      <Field label="Current password"><Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} data-testid="change-pw-current-input" /></Field>
      <Field label="New password (min 8)"><Input type="password" value={nw} onChange={(e) => setNw(e.target.value)} data-testid="change-pw-new-input" /></Field>
      <Button onClick={save} disabled={!cur || nw.length < 8} data-testid="change-pw-save-btn">Update password</Button>
    </section>
  );
}

export default function Settings() {
  const { can, user } = useAuth();
  return (
    <div className="space-y-4">
      <PageHeader title="Settings" subtitle="Account security and master configuration." />
      {user.must_change_password && <div className="rounded-md border border-red-500/40 bg-red-500/10 p-3 text-sm text-red-700 dark:text-red-400" data-testid="must-change-password-banner">You are using a temporary password. Set a new password to continue.</div>}
      <div className="grid lg:grid-cols-2 gap-4"><Password /></div>
      {can("settings:write") && <Lookups />}
    </div>
  );
}
